import { render } from "./psychologicalCounseling.vue?vue&type=template&id=2a8035d7&scoped=true"
import script from "./psychologicalCounseling.vue?vue&type=script&lang=js"
export * from "./psychologicalCounseling.vue?vue&type=script&lang=js"

import "./psychologicalCounseling.vue?vue&type=style&index=0&id=2a8035d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8035d7"]])

export default __exports__